import { render, staticRenderFns } from "./ParcelList.vue?vue&type=template&id=23a1ab62&"
import script from "./ParcelList.vue?vue&type=script&lang=ts&"
export * from "./ParcelList.vue?vue&type=script&lang=ts&"
import style0 from "./ParcelList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports